var slider_routine = {
  init: function () {
    console.log("Routine init");

      $(".routine-container .jdgm-widget:first-child").addClass("visible");

    var _carousel = $(".routine-container .slider-container");
    _carousel.slick({
			arrows:true,
			dots:false,
			infinite: false,
			variableWidth:true,
			slidesToShow: 1,
			focusOnSelect: true,
			touchThreshold:500,
			prevArrow: _carousel.parent().find(".arrow-container.left"),
			nextArrow: _carousel.parent().find(".arrow-container.right"),
		});
    _carousel.on('beforeChange', function(event, slick, currentSlide, nextSlide){
      var infos = slider_routine.get_related_product_infos(nextSlide);
      slider_routine.update_related_product_infos(infos, nextSlide);
    });
  },
  get_related_product_infos: function (index) {
    return related_products[index];
  },
  update_related_product_infos: function (infos, index) {
    $('.background').removeClass('animated').addClass('transition');
    $('.product-suggestion-container').removeClass('animated').addClass('transition');
    $('.background').css("background-image", "url(" + infos.image + ")");
    var type = $('.product-card .product-title ');
    var titre = $('.product-card .product-title .product-name');
    titre.text(" "+unescape(infos.titre));
    type.html(unescape(infos.type));
    type.append(titre);
    $('.product-card .primary__color').html(unescape(infos.description));
    $('.step .number').text(infos.index);
    $('.product-card .links a').attr('href', infos.lien);

    // SHOW ACCORDING REVIEWS
      $(".routine-container .jdgm-widget").each(function(){
          if($(this).index() == index){
              $(this).addClass("visible");
          }else{
              $(this).removeClass("visible");
          }
      })


    setTimeout(function () {
      $('.background').removeClass('transition').addClass('animated');
      $('.product-suggestion-container').removeClass('transition').addClass('animated');
    }, 40);
  }
}
$(window).on("load", function () {
  if ($(".akrolab-template .routine-container").length) {
    slider_routine.init();
  }
})
